<template>
  <v-card :elevation="0" class="pb-2 d-flex flex-column align-center">
    <a :href="url" target="_blank" v-if="qrCode">
      <v-img
        height="200"
        width="200"
        :src="qrCode"
      ></v-img>
    </a>
    <v-card-text>
      <div class="d-flex flex-column align-center">
        <template v-if="!timerIsNull && qrCode">
          <p v-html="diiaLink"></p>
          <p>{{$t('eds.qrTime', {time: time})}}</p>
        </template>
        <template v-else>
          <span>{{$t('eds.tryLater')}}</span>
        </template>
      </div>
    </v-card-text>
    <v-btn color="blue-grey darken-1" @click="generateNewQR()">{{$t('eds.generateNewQR')}}</v-btn>
    </v-card>
</template>
<script>
import moment from 'moment'
export default {
  props: ['url', 'qrCode'],
  data: () => ({
    date: moment(60 * 3 * 1000),
    timer: null
  }),
  mounted() {
    this.timer = setInterval(this.startTimer, 1000)
  },
  destroyed() {
    this.stopTimer()
  },
  methods: {
    startTimer() {
      this.date = moment(this.date.subtract(1, 'seconds'))
      if (this.timerIsNull) {
        this.$emit('clearDataDiia')
        this.stopTimer()
      }
    },
    stopTimer() {
      clearInterval(this.timer)
    },
    generateNewQR() {
      this.$emit('generateNewQR')
      this.stopTimer()
      this.date = moment(60 * 3 * 1000)
      this.timer = setInterval(this.startTimer, 1000)
    }
  },
  computed: {
    time() {
      return this.date.format('mm:ss')
    },
    timerIsNull() {
      return this.time.toString() === '00:00'
    },
    diiaLink() {
      return this.$t('eds.scanQR', { diia: `<a class="black--text" href="${this.url}" target="_blank">${this.$t('eds.diia')}</a>` })
    }
  }
}
</script>